import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PopUp from '../../Shared/Popup/PopUp';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { validateInput, TextInputEnum } from '../../../utilities/validation/InputValidation';
import AddressFrm from 'app/Components/Shared/AddressFrm/AddressFrm';
import ProviderManager from '../../../provider/providerManager';
import Config from 'app/Config';
import './EntityFormComponent.scss';
import images from './images/images';
import checkIcon from './images/check.svg';
const EntityFormComponent = (props) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);
  const [showIdValidationPopup, setShowIdValidationPopup] = useState(false);
  const [idValidationMessage, setIdValidationMessage] = useState('');
  const [showExceedingEntityPopup, setShowExceedingEntityPopup] = useState(false);
  const [isValidatingId, setIsValidatingId] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [id, setId] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isAddressValid, setIsAddressValid] = useState(null);
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
  const [hasShownIdChangePopup, setHasShownIdChangePopup] = useState(false);
  const firstNameRef = useRef(null);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    if (firstNameRef.current) {
      firstNameRef.current.focus();
    }
  }, []);

  // Prevent body scroll when popup is open
  useEffect(() => {
    if (showPopUp || showIdValidationPopup || showExceedingEntityPopup) {
      document.body.classList.add('popup-open');
    } else {
      document.body.classList.remove('popup-open');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('popup-open');
    };
  }, [showPopUp, showIdValidationPopup, showExceedingEntityPopup]);

  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    id: '',
    file: '',
    terms: '',
    address: ''
  });

  const clearError = (field) => {
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    clearError('file');
  };

  const handleFileRemove = () => {
    setSelectedFile(null);
    // Reset the file input
    const fileInput = document.getElementById('id-photo-upload');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handlePopUpClick = () => {
    setShowPopUp(true);
  };

  const handleAddressValid = (isValid) => {
    setIsAddressValid(isValid);

    if (isValid) {
      const hasAddressData = props.addressForm?.cityName &&
                            props.addressForm?.streetName &&
                            props.addressForm?.home;

      if (hasAddressData) {
        setErrors(prev => ({
          ...prev,
          address: ''
        }));
      }
    }
  };

  const handleAddressError = (error) => {
    setErrors(prev => ({
      ...prev,
      address: 'יש להזין כתובת תקינה'
    }));
  };

  const validateExceedingPayingEntity = async (idNumber) => {
    try {
      setIsValidatingId(true);
      const params = {
        idNumber: idNumber,
        idType: 'I',
        marketCode: props.marketCode || 'CLC',
      };

      const result = await ProviderManager.getProviderData('IsExceedingPayingEntityMax', params);

      if (result && result.Body) {
        if (result.Body.isExceedingPayingEntityMax === true || result.Body.isExceedingPayingEntityMax === 'true') {
          setShowExceedingEntityPopup(true);
          return false;
        }
        return true;
      } else {
        setShowExceedingEntityPopup(true);
        return false;
      }
    } catch (error) {
      console.error('Error validating exceeding paying entity:', error);
      setShowExceedingEntityPopup(true);
      return false;
    } finally {
      setIsValidatingId(false);
    }
  };

    const validateIdNumber = async (idNumber) => {
    try {
      setIsValidatingId(true);
      const params = {
        idNumber: idNumber
      };

      const result = await ProviderManager.getProviderData('IsIdNumberValid', params);

      if (result && result.Body) {
        if (result.Body.isValid === true) {
          return true;
        } else {
          setIdValidationMessage(result.Body.message || 'מספר תעודת הזהות אינו תקין');
          setShowIdValidationPopup(true);
          return false;
        }
      } else {
        setIdValidationMessage('שגיאה בבדיקת תעודת הזהות. נסה שוב מאוחר יותר');
        setShowIdValidationPopup(true);
        return false;
      }
    } catch (error) {
      console.error('Error validating ID number:', error);
      setIdValidationMessage('שגיאה בבדיקת תעודת הזהות. נסה שוב מאוחר יותר');
      setShowIdValidationPopup(true);
      return false;
    } finally {
      setIsValidatingId(false);
    }
  };

    const isFormValid = () => {
    const isFirstNameValid = validateInput(firstName, TextInputEnum.FirstName) === '';
    const isLastNameValid = validateInput(lastName, TextInputEnum.LastName) === '';
    const isPhoneValid = validateInput(phone, TextInputEnum.Phone) === '';
    const isIdValid = validateInput(id, TextInputEnum.Id) === '';
    const isFileValid = selectedFile !== null;
    const isTermsValid = termsAccepted;

    const hasAddressData = !!(props.addressForm?.cityName &&
                            props.addressForm?.streetName &&
                            props.addressForm?.home);



    return isFirstNameValid && isLastNameValid && isPhoneValid && isIdValid &&
           isFileValid && isTermsValid && hasAddressData;
  };

  const validateForm = () => {
    const newErrors = {};

    newErrors.firstName = validateInput(firstName, TextInputEnum.FirstName);
    newErrors.lastName = validateInput(lastName, TextInputEnum.LastName);
    newErrors.phone = validateInput(phone, TextInputEnum.Phone);
    newErrors.id = validateInput(id, TextInputEnum.Id);

    if (!selectedFile) {
      newErrors.file = 'צילום תעודת זהות הוא שדה חובה';
    }

    if (!termsAccepted) {
      newErrors.terms = 'יש לאשר את תנאי השימוש';
    }

    const hasAddressData = !!(props.addressForm?.cityName &&
                            props.addressForm?.streetName &&
                            props.addressForm?.home);

    if (!hasAddressData) {
      newErrors.address = 'יש להזין כתובת תקינה';
    }

    setErrors(newErrors);

    return Object.values(newErrors).every(error => error === '');
  };

  const handleSubmit = async () => {
    setHasAttemptedSubmit(true);

    if (validateForm()) {
      const isNotExceeding = await validateExceedingPayingEntity(id);
      if (!isNotExceeding) return;

      const isIdValid = await validateIdNumber(id);

      if (isIdValid) {
        const addressData = {
          city: props.addressForm?.cityName || '',
          street: props.addressForm?.streetName || '',
          home: props.addressForm?.home || '',
          apartment: props.addressForm?.apartment || '',
          zipCode: props.addressForm?.zipCode || ''
        };

        const formData = {
          firstName,
          lastName,
          phone,
          id,
          selectedFile,
          termsAccepted,
          isAddressValid,
          addressData
        };

        if (props.onFormSubmit) {
          props.onFormSubmit(formData);
        }
      }
    } else {
    }
  };

  return(
    <>
<div className='entity-form-page-wrapper'>
       <div className="entity-form-content">
      <span className="content-header">פרטי המשלם</span>
      <div className="feilds-bulk">
        <div className="input-wrapper first-name-wrapper">
          <input
            ref={firstNameRef}
            type="text"
            className="txt-fieldsingle"
            placeholder='שם פרטי'
            dir="rtl"
            value={firstName}
            onChange={(e) => {
              setFirstName(e.target.value);
              clearError('firstName');
            }}
          />
          {!firstName && <span className="required-asterisk">*</span>}
        </div>

        <div className="input-wrapper last-name-wrapper">
          <input
            type="text"
            className="txt-fieldsingle"
            placeholder='שם משפחה'
            dir="rtl"
            value={lastName}
            onChange={(e) => {
              setLastName(e.target.value);
              clearError('lastName');
            }}
          />
          {!lastName && <span className="required-asterisk">*</span>}
        </div>

        <div className="input-wrapper phone-wrapper">
          <input
            type="tel"
            className="txt-fieldsingle"
            placeholder='טלפון נייד'
            dir="rtl"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
              clearError('phone');
            }}
          />
          {!phone && <span className="required-asterisk">*</span>}
        </div>

        <div className="input-wrapper id-wrapper">
          <input
            type="tel"
            className="txt-fieldsingle"
            placeholder='מספר ת.ז'
            dir="rtl"
            value={id}
            onChange={(e) => {
              setId(e.target.value);
              clearError('id');

              // Show popup if user changes ID after uploading file and we haven't shown it yet
              if (selectedFile && !hasShownIdChangePopup && e.target.value !== id) {
                setShowPopUp(true);
                setHasShownIdChangePopup(true);
              }
            }}
          />
          {!id && <span className="required-asterisk">*</span>}
        </div>
      </div>
      <div className="upload-card-explanation">
        <div className={`upload-component ${selectedFile ? 'has-file' : ''}`}>
          <input
            type="file"
            id="id-photo-upload"
            accept=".pdf,.jpg,.jpeg,application/pdf,image/jpeg"
            onChange={handleFileSelect}
            style={{display: 'none'}}
          />
          <label htmlFor="id-photo-upload" className="upload-component-label">
            <span>צילום ת.ז *</span>
            {selectedFile && (
              <>
                <br />
                <div className="filename-container">
                  <div
                    className="file-remove-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleFileRemove();
                    }}
                    style={{cursor: 'pointer'}}
                  >
                    ✕
                  </div>
                  <span className="filename">{selectedFile.name}</span>
                </div>
              </>
            )}
          </label>
        </div>
        <a onClick={handlePopUpClick} className="file-link-explanation" style={{cursor: 'pointer'}}>
          למה אנחנו צריכים צילום ת.ז?
        </a>
      </div>

      <div className="fields-address">
        <AddressFrm
          title="כתובת מגורים"
          isApartmentRequired={false}
          noDefaultValuesOnRender={true}
          avoidGaReport={true}
          onValid={handleAddressValid}
          onError={handleAddressError}
          dontAutoFocus={true}
        />
      </div>
    </div>
    <div className="btn-div">
      <div className="checkbox">
        <label className={`checkbox-control ${termsAccepted ? 'checked' : ''}`} htmlFor="terms">
          <input
            type="checkbox"
            id="terms"
            checked={termsAccepted}
            onChange={(e) => {
              setTermsAccepted(e.target.checked);
              clearError('terms');
            }}
          />
          {termsAccepted && (
            <Image src={checkIcon} alt='check' />
          )}
        </label>
        <label htmlFor="terms" className="-\31--5-">
          אני מאשר/ת את{' '}
          <a href={props.iContent.termsLink.value} className="text-style-1" onClick={(e) => e.preventDefault()} style={{textDecoration: 'underline', color: 'var(--theme-primary, #9631ff)'}}>
            תנאי השימוש
          </a>
        </label>
      </div>

      {!isFormValid() && hasAttemptedSubmit && !isValidatingId && (
        <div className="validation-message">
          כדי להמשיך יש למלא את פרטי המשלם
        </div>
      )}

      <button
        className="h50primary"
        style={{
          width: '100%',
          height: '50px'
        }}
        onClick={handleSubmit}
      >
        <span className='btn-text'>
          {isValidatingId ? 'מתבצעת בדיקה...' : 'המשך לעדכון פרטי אשראי'}
        </span>
      </button>
    </div>
    </div>

    <PopUp
      showPopUp={showPopUp}
      onClose={() => setShowPopUp(false)}
      className="centered-popup"
    >
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>
        <Image src={images.important} style={{width: '100px', height: '100px'}} />
        </div>
        <h2 style={{display: 'flex', justifyContent: 'center', fontFamily: 'sans-serif',fontWeight: 'bold'}}>חשוב לנו שתדעו</h2>
        <p>
          כדי לשמור עליך אנחנו צריכים לוודא שאנחנו <br/> מעדכנים את אמצעי התשלום הנכון, לכן עלינו <br/> לבצע זיהוי ושיוך של כרטיס האשראי <br/> באמצעות צילום ת.ז
        </p>
        <div className="popup-button-container">
          <BtnSubmit
            text="הבנתי, תודה"
            onclick={() => setShowPopUp(false)}
          />
        </div>
      </div>
    </PopUp>

    <PopUp
      showPopUp={showIdValidationPopup}
      onClose={() => setShowIdValidationPopup(false)}
      className="centered-popup"
    >
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>
          <Image src={images.importantIcon} style={{width: '120px', height: '120px'}} />
        </div>
        <h2 style={{display: 'flex', justifyContent: 'center',textAlign: 'center',fontFamily: 'Aa_TypoCellcomBold',fontSize: '23px',fontWeight: '800'}}>לא ניתן להגדיר את תעודת <br/> הזהות הזו כמשלם</h2>
                 <BtnSubmit
           text="הבנתי"
           onclick={() => setShowIdValidationPopup(false)}
           style={{width: '290px'}}
         />
      </div>
    </PopUp>

    <PopUp
      showPopUp={showExceedingEntityPopup}
      onClose={() => { setShowExceedingEntityPopup(false); window.location.href = Config.lobbyUrl; }}
      className="centered-popup"
    >
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>
          <img src={images.importantIcon} style={{width: '120px', height: '120px'}}></img>
        </div>
        <h2 style={{display: 'flex', justifyContent: 'center',textAlign: 'center',fontFamily: 'Aa_TypoCellcomBold',fontSize: '23px',fontWeight: '800'}}>לא ניתן להגדיר את תעודת <br/> הזהות הזו כמשלם</h2>
        <button
          className="btn-submit"
          style={{width: '250px'}}
          onClick={() => { setShowExceedingEntityPopup(false); window.location.href = Config.lobbyUrl; }}
        >
          <span className="btn-submit__label">הבנתי</span>
        </button>
      </div>
    </PopUp>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    addressForm: state.addressForm.form,
    marketCode: state.domain?.MarketCode,
  };
};

export default connect(mapStateToProps)(EntityFormComponent);
